import React from "react";
import { Navigate } from "react-router-dom";
import { isAuthenticated, hasPermission } from "../services/auth";

const PrivateRoute = ({ children, permission }) => {
  if (!isAuthenticated()) {
    return <Navigate to='/sign-in' replace />;
  }
  if (permission && !hasPermission(permission)) {
    return <Navigate to='/access-denied' replace />;
  }
  return children;
};

export default PrivateRoute;
